var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanAr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.537,
    height: 95.368,
    viewBox: "0 0 50.537 95.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 15.072,
    height: 18.409,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scanAR",
    transform: "translate(1.015 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M31.041,252l-4.89,10.715L1.917,252l5.308-10.915Z",
    transform: "translate(-1.917 -169.083)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M100.147,221.084s-2.2,4.606-3.906,6.008-3.94,1.8-4.824,3a65.291,65.291,0,0,0-3.2,6.446",
    transform: "translate(-62.293 -155.091)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M29.464,150.368s2.6-6.009,0-10.515a22.248,22.248,0,0,0-6.008-6.81l-1.8-5.508a9.408,9.408,0,0,0,0-6.109c-1.2-2.8-2.9-4.907-5.808-4.707s-2.1,3.805-2.1,3.805a14.872,14.872,0,0,1-.7,5.808c-1,2.6-.4,9.313.5,12.117s1.9,7.411,2.8,10.415a9.012,9.012,0,0,1,.4,4.707l-.641,1.171",
    transform: "translate(-9.335 -82.071)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M62.263,63.706H80.79s3.805-1.3,3.805-4.406V5.724s.2-4.306-5.408-4.306H54.552a4.242,4.242,0,0,0-4.164,4.406V35.366",
    transform: "translate(-35.826 -1.418)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M74.25,62.084h-6v6.109",
    transform: "translate(-48.322 -43.859)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M68.251,121.418v5.508h6",
    transform: "translate(-48.322 -85.367)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M127.917,126.926h5.207v-5.508",
    transform: "translate(-90.064 -85.367)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M131.959,67.893V62.085h-5.708",
    transform: "translate(-88.898 -43.859)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(23.921 20.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M5.284,7.837l-.407,3.155a8.19,8.19,0,0,0-2.019.947,6.418,6.418,0,0,0-2.43,3.6c-.2.947-.252,1.92-.416,2.874,1.2-.01,2.407,0,3.61,0h11.45a26.653,26.653,0,0,0-.292-2.682,5.8,5.8,0,0,0-2.646-3.786,6.082,6.082,0,0,0-1.388-.631,5.169,5.169,0,0,0-.694-.158,22.556,22.556,0,0,1-.189-3.376,9.725,9.725,0,0,1,.968-.418,4.368,4.368,0,0,0,1.156-.938,3.069,3.069,0,0,0,.337-.536,3.573,3.573,0,0,0,.846.247,1.974,1.974,0,0,0,1.71-.847l.193-.354L11.945,3.641c-.1-.04-.206-.2-.282-.273a5.71,5.71,0,0,0-.84-.647s-.046-.941.207-1.225a1.037,1.037,0,0,1,.663-.41.489.489,0,0,1,.347.063.674.674,0,0,0-.473.379.759.759,0,0,0,.085.894.887.887,0,0,0,.928.1,1.155,1.155,0,0,0,.58-.709c.019-.063.1-.734.019-.731,0,0,.6-.025.659-.12s.032-.252-.221-.252-.631.032-.631.032a2.237,2.237,0,0,1-.235-.27,1.466,1.466,0,0,0-.517-.356,1.823,1.823,0,0,0-1.307.021,2.293,2.293,0,0,0-1,.81,1.778,1.778,0,0,0-.273.559c-.019.066-.157.695-.081.714a9.719,9.719,0,0,0-1.2-.192,7.658,7.658,0,0,0-2.579.134c-.284.063-.725.221-.726.221.089-.032-.365-.981-.418-1.059a2.2,2.2,0,0,0-1.3-.906,1.619,1.619,0,0,0-1.844.8,5.639,5.639,0,0,0-.674.056c-.147.039-.241.07-.241.165s.252.126.379.126.409.031.41.032a1.5,1.5,0,0,0-.038.42,1.237,1.237,0,0,0,.278.636c.331.393,1.135.56,1.408.012a.812.812,0,0,0-.5-1.053c-.221-.063-.126-.032-.126-.032s.063-.126.442-.063a.887.887,0,0,1,.694.473,1.639,1.639,0,0,1,.219.585,2.271,2.271,0,0,1,.033.394l-.631.631A3.992,3.992,0,0,1,2,4.116Q1,4.542.011,4.969c-.1.043.506.695.574.745a1.925,1.925,0,0,0,2.162.12c-.061.038.576.81.639.873a6.458,6.458,0,0,0,1.9,1.131",
    transform: "translate(0.001 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanAr);
export default __webpack_public_path__ + "static/media/scanAR.e2f70883.svg";
export { ForwardRef as ReactComponent };